import { Component, OnInit } from '@angular/core';
import { NavbarComponent } from '../../components/navbar/navbar.component';
import { DxButtonModule, DxTabPanelModule } from 'devextreme-angular';
import { Router, ActivatedRoute } from '@angular/router';
import { MonitoringOverviewComponent } from '../monitoring-overview/monitoring-overview.component';

@Component({
  selector: 'app-home',
  imports: [
    NavbarComponent,
    DxButtonModule,
    DxTabPanelModule,
    MonitoringOverviewComponent
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent implements OnInit {
  
    constructor(private router: Router, private route: ActivatedRoute) { }
  
    selectedIndex: number = 0;
  
      availableTabs = [
      { 'id': 'home', 'title': 'MiG Aktualisierung', 'icon': 'refresh', 'template': 'monitoring'}
    ]
  
      ngOnInit() {
      // set the displayed tab to the one corresponding to the curent route
      this.route.paramMap.subscribe(params => {
        const tabID = params.get('tabID');
        const tabIndex = this.availableTabs.findIndex(tab => tab.id === tabID);
  
        if(tabIndex != -1) {
          this.selectedIndex = tabIndex;
        }
        else {
          this.router.navigate(['/']);
        }
  
      })
    }
  
  
    /**
     * Update the URL when changing the tab
     * @param e
     *  The event fired by the tab component
     */
    onTabChange(e: any) {
      const newTab = e.addedItems[0];
      this.router.navigate(['../', newTab.id], { relativeTo: this.route });
    }
  
  
  }
  